import React from 'react'
import { Link, graphql  } from 'gatsby'
import Card from '../components/Card'
// import react from '../assets/images/react-js.png'
// import vue from '../assets/images/vue.png'
// import angular from '../assets/images/angular.png'
// import hero from '../assets/images/hero.png'
import Img from 'gatsby-image'
import Banner from '../components/Banner'
import 'bootstrap/dist/css/bootstrap.css';

const Blog = ({ data }) => {
    if(data){
      console.log("data there");
    }

    const styles = {
        hero: {
            height: '30vh'
        }
    }
    const headings = {
        react : "React is a JavaScript library for building user interfaces. Learn what React is all about on our homepage or in the tutorial.",
        vue: "Vue (pronounced /vjuː/, like view) is a progressive framework for building user interfaces. Unlike other monolithic frameworks, ",
        angular: "AngularJS is a structural framework for dynamic web apps. It lets you use HTML as your template language and lets you extend HTML.."
    }
    return ( 
        <> 
            <nav className="navbar navbar-expand-md navbar-dark bg-dark sticky-top">   
              <div className="container">
                  <Link to="/" className="navbar-brand">Cj Coder</Link>
              </div>    
            </nav> 
           <Banner />
            <div className="container">
                 <div className="row mt-5">
                 { data.allMarkdownRemark.edges.map(post => {
                    return ( 
                       <div className="col-md-4 col-sm-12">
                         <Card body="Programming" articlePic={post.node.frontmatter.featuredImage.childImageSharp.fluid} title={post.node.frontmatter.title} path={post.node.frontmatter.path} sub={post.node.frontmatter.SubHeading} />
                       </div>
                    )  
                }) }
                </div>
          </div>
        </>
     );
}

export const pageQuery = graphql`
  query blogIndex {
    allMarkdownRemark{
      edges {
        node{
          id
          frontmatter{
            title
            path
            author
            date
            SubHeading
            featuredImage {
              childImageSharp {
                fluid(maxWidth: 800) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          excerpt
        }
      }
    }
  }
`

export default Blog;